// 将数组转换为map
export const arrayToMap = (list, key) => {
  return list.reduce((pre, cur) => {
    pre[cur[key]] = cur
    return pre
  }, {})
}
